import { render, staticRenderFns } from "./UploadFilesArea.vue?vue&type=template&id=16b229e6&scoped=true&"
import script from "./UploadFilesArea.vue?vue&type=script&lang=ts&"
export * from "./UploadFilesArea.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFilesArea.vue?vue&type=style&index=0&id=16b229e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b229e6",
  null
  
)

export default component.exports